import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, MessageCircle } from "lucide-react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import { useUiTexts } from "@/lib/uiTexts";

function FaqItem({ item, open, onToggle }) {
  return (
    <div className="card-tactical overflow-hidden" data-testid={`faq-item-${item.id}`}>
      <button onClick={onToggle} data-testid={`faq-question-${item.id}`}
        className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-orange-500/5">
        <span className="font-heading text-lg font-bold uppercase tracking-tight">{item.question}</span>
        <ChevronDown className={`h-5 w-5 shrink-0 text-orange-500 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <div className="overflow-hidden">
          <p className="whitespace-pre-line px-5 pb-5 text-sm leading-relaxed text-slate-400">{item.answer}</p>
        </div>
      </div>
    </div>
  );
}

export default function Faq() {
  const texts = useUiTexts();
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/faq").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page" className="page-enter mx-auto max-w-4xl px-4 py-16 sm:px-8 lg:py-24">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">{texts.faq_label}</p>
        <h1 className="mt-2 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl lg:text-4xl">{texts.faq_title}</h1>
        <p className="mt-3 text-slate-400">
          Livraison, retours, paiement, tailles : toutes les réponses aux questions de la communauté.
        </p>
      </Reveal>
      <div className="mt-10 grid gap-4">
        {items.map((item, i) => (
          <Reveal key={item.id} delay={i * 0.05} y={20}>
            <FaqItem item={item} open={openId === item.id} onToggle={() => setOpenId(openId === item.id ? null : item.id)} />
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <div className="card-tactical mt-10 flex flex-wrap items-center justify-between gap-4 p-6">
          <div className="flex items-center gap-3">
            <MessageCircle className="h-6 w-6 text-orange-500" />
            <p className="text-sm text-slate-300">Une autre question ? L'équipe vous répond sous 48h.</p>
          </div>
          <Link to="/contact" data-testid="faq-contact-link"
            className="rounded-xl bg-orange-500 px-5 py-2.5 font-heading text-base font-bold uppercase tracking-wide text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400 active:scale-[0.98]">
            Nous contacter
          </Link>
        </div>
      </Reveal>
    </div>
  );
}
